module.exports = __webpack_public_path__ + "public/img/tiku_cbg4.e3cf69da.png";